/* ============================================
   WILL WYATT CONCEPT — THEME JS
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {

  // --- Fixed Header: single wrapper handles everything ---
  var headerWrapper = document.querySelector('.header-wrapper');

  function setBodyPadding() {
    if (headerWrapper) {
      document.body.style.paddingTop = headerWrapper.offsetHeight + 'px';
    }
  }

  // Set body padding on load
  setBodyPadding();

  // Recalculate on resize
  window.addEventListener('resize', setBodyPadding);

  // Recalculate after images load (logo may change height)
  window.addEventListener('load', setBodyPadding);

  // --- Scroll: add .scrolled class ---
  if (headerWrapper) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 50) {
        headerWrapper.classList.add('scrolled');
      } else {
        headerWrapper.classList.remove('scrolled');
      }
      // Recalc padding since header may shrink
      setBodyPadding();
    });
  }

  // --- Mobile Menu ---
  var menuToggle = document.querySelector('.mobile-menu-toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  var mobileOverlay = document.querySelector('.mobile-overlay');
  var mobileClose = document.querySelector('.mobile-nav__close');

  function openMobileMenu() {
    if (mobileNav) mobileNav.classList.add('open');
    if (mobileOverlay) mobileOverlay.classList.add('open');
    document.body.classList.add('no-scroll');
  }

  function closeMobileMenu() {
    if (mobileNav) mobileNav.classList.remove('open');
    if (mobileOverlay) mobileOverlay.classList.remove('open');
    document.body.classList.remove('no-scroll');
  }

  if (menuToggle) menuToggle.addEventListener('click', openMobileMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

  // --- FAQ Accordion ---
  var faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(function(item) {
    var question = item.querySelector('.faq-item__question');
    if (question) {
      question.addEventListener('click', function() {
        var isOpen = item.classList.contains('open');
        faqItems.forEach(function(other) {
          other.classList.remove('open');
        });
        if (!isOpen) {
          item.classList.add('open');
        }
      });
    }
  });

  // --- Fade Up Animation on Scroll ---
  var fadeElements = document.querySelectorAll('.fade-up');
  if (fadeElements.length > 0) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    fadeElements.forEach(function(el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight) {
        el.classList.add('visible');
      } else {
        observer.observe(el);
      }
    });
  }

  // --- Smooth Scroll for Anchor Links ---
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

});
